import React, { Suspense, lazy, Component } from 'react';
import { Hero } from '../sections/Hero';
import { SimpleCalculator } from '../sections/SimpleCalculator';
// Lazy load componentes que no son críticos para el first paint
const HowItWorks = lazy(() => import('../sections/HowItWorks').then(m => ({
  default: m.HowItWorks
})));
const Manage = lazy(() => import('../sections/Manage').then(m => ({
  default: m.Manage
})));
const Logos = lazy(() => import('../sections/Logos').then(m => ({
  default: m.Logos
})));
// Componente de loading simple
const SectionLoader = () => <div className="py-12 md:py-20 flex items-center justify-center" data-id="element-338">
    <div className="w-8 h-8 border-4 border-[#2B5FD9] border-t-transparent rounded-full animate-spin" data-id="element-339" />
  </div>;
export default function Home() {
  return <>
      <Hero data-id="element-340" />
      <Suspense fallback={<SectionLoader data-id="element-342" />} data-id="element-341">
        <HowItWorks data-id="element-343" />
      </Suspense>
      <Suspense fallback={<SectionLoader data-id="element-345" />} data-id="element-344">
        <Manage data-id="element-346" />
      </Suspense>
      <SimpleCalculator data-id="element-347" />
      <Suspense fallback={<SectionLoader data-id="element-349" />} data-id="element-348">
        <Logos data-id="element-350" />
      </Suspense>
    </>;
}